// Browser-side document fingerprint for /verify: the PDF never leaves the device (spec § Verify page).

export const MAX_VERIFY_BYTES = 100 * 1024 * 1024

export async function sha256Hex(data: ArrayBuffer): Promise<string> {
  const digest = await globalThis.crypto.subtle.digest('SHA-256', data)
  return [...new Uint8Array(digest)].map(b => b.toString(16).padStart(2, '0')).join('')
}

export function isPdfFile(file: Pick<File, 'name' | 'type'>): boolean {
  return file.type === 'application/pdf' || /\.pdf$/i.test(file.name)
}

/** Throws Error('NOT_PDF') or Error('TOO_LARGE') before reading the file. */
export async function hashPdfFile(file: File): Promise<string> {
  if (!isPdfFile(file)) throw new Error('NOT_PDF')
  if (file.size > MAX_VERIFY_BYTES) throw new Error('TOO_LARGE')
  return sha256Hex(await file.arrayBuffer())
}
